import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

export default class ButtonSwitch extends Component {
    render() {
        const { active, icon, activeIcon, iconSize, testId } = this.props;
        const iconToDisplay = active && activeIcon ? activeIcon : icon;
        return <Button iconSize={iconSize} type="switch" {...this.props} icon={iconToDisplay} testId={testId} />;
    }
}

ButtonSwitch.defaultProps = {
    testId: 'button-switch',
    isBtnIcon: false,
    disabled: false,
    children: null,
    size: undefined,
    className: '',
    label: '',
    icon: null,
    activeIcon: null,
    iconSize: 22,
    isLoading: false,
    active: false,
    onClick: null,
};

ButtonSwitch.propTypes = {
    testId: PropTypes.string,
    isBtnIcon: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['large', 'small', 'mini', undefined]),
    isLoading: PropTypes.bool,
    active: PropTypes.bool,
    label: PropTypes.string,
    icon: PropTypes.string,
    activeIcon: PropTypes.string,
    iconSize: PropTypes.number,
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node,
};
